import React from 'react';
import { observer } from 'mobx-react-lite';
import ProductLineTitleV2 from 'components/common/general/ProductLineTitleV2';
import { useZywaveRedirectPageStore } from 'store/pages/quote/zywave-redirect-page/pageStore';
import SectionTitle from 'components/common/general/SectionTitle';
import {
  ProductLineCardStyled,
  ProductLinesGridStyled,
  ProductLineTitleSlotStyled,
  SectionWrapperStyled,
  StatLabelStyled,
  StatListStyled,
  StatRowStyled,
  StatValueStyled,
} from './styles';

export const StatisticsByProductLines: React.FC = observer(() => {
  const { quotingStatistics } = useZywaveRedirectPageStore();

  if (!quotingStatistics) {
    return null;
  }

  return (
    <SectionWrapperStyled>
      <SectionTitle text="Interested Product Lines" />
      <ProductLinesGridStyled>
        {quotingStatistics.productLineStat.map((stat) => {
          return (
            <ProductLineCardStyled key={stat.productLineId}>
              <ProductLineTitleSlotStyled>
                <ProductLineTitleV2 productLineId={stat.productLineId} />
              </ProductLineTitleSlotStyled>
              <StatListStyled>
                <StatRowStyled>
                  <StatLabelStyled>Employees (no dependents)</StatLabelStyled>
                  <StatValueStyled>{stat.eesOnly}</StatValueStyled>
                </StatRowStyled>
                <StatRowStyled>
                  <StatLabelStyled>Employees with dependents</StatLabelStyled>
                  <StatValueStyled>{stat.eesWithDeps}</StatValueStyled>
                </StatRowStyled>
                <StatRowStyled>
                  <StatLabelStyled>Dependents</StatLabelStyled>
                  <StatValueStyled>{stat.depsTotal}</StatValueStyled>
                </StatRowStyled>
              </StatListStyled>
            </ProductLineCardStyled>
          );
        })}
      </ProductLinesGridStyled>
    </SectionWrapperStyled>
  );
});
